<form #loginForm="ngForm" (ngSubmit)="doLogin(loginForm.value)" style="padding:1em; overflow:auto;">
    <h2>
        Acumatica log in
    </h2>

    <mat-error *ngIf="errorMessage" color="warn">{{ errorMessage }}</mat-error>

    <mat-form-field>
        <mat-label>Username</mat-label>
        <input id="username" name="username" (keydown.enter)="this.password.focus()" matInput ngModel required />
    </mat-form-field>

    <mat-form-field>
        <mat-label>Password</mat-label>
        <input type="password" id="password" name="password" (keydown.enter)="doLogin(loginForm.value)" matInput ngModel
            required #password />
    </mat-form-field>

    <div>
        <button type="button" mat-raised-button color="primary" style="width:100%;" [disabled]="isLoading"
            (click)="doLogin(loginForm.value)">Sign In
            <mat-spinner *ngIf="isLoading" diameter=25 style="display:inline-block; margin-left:0.5rem;" color="accent">
            </mat-spinner>
        </button>
    </div>
</form>